import { Title, useMantineTheme } from '@mantine/core'
import { IconLaurelWreath1, IconLaurelWreath2, IconLaurelWreath3 } from '@tabler/icons-react'
import React from 'react'

import { bronzeColor, silverColor } from '@/utils/utils'

interface PodiumIconProps {
  index: number
}

const PodiumIcon: React.FC<PodiumIconProps> = ({ index }) => {
  const theme = useMantineTheme()

  if (index === 0) {
    return <IconLaurelWreath1 color={theme.colors.barChartYellow[0]} />
  }
  if (index === 1) {
    return <IconLaurelWreath2 color={silverColor} />
  }
  if (index === 2) {
    return <IconLaurelWreath3 color={bronzeColor} />
  }
  return <Title order={5}>{index + 1}.</Title>
}

export default PodiumIcon
